import React from 'react';
import clsx from 'clsx';

import { shape, bool } from 'prop-types';
import styles from './ProductHeader.module.scss';

const ProductHeader = ({ data, animateOut }) => (
  <div className={clsx(styles.wrapper, { [styles.fadeOut]: animateOut })}>
    <span className={styles.preheader}>{data.categoryTitleText}</span>
    <h3 className={styles.header}>{data.titleText}</h3>
  </div>
);

ProductHeader.propTypes = {
  data: shape({}).isRequired,
  animateOut: bool.isRequired,
};

export default ProductHeader;
